// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__Oy61D","upload":"Small_upload__2iVLe","imageWrap":"Small_imageWrap__3w4ML","removeBtn":"Small_removeBtn__SE_26"};